import React, { useContext } from 'react'
import { StateContext } from '../../services/StateService'
import RichContent from '../../components/RichContent'

/* istanbul ignore next */
const PostPurchaseForm = () => {
    const { postPurchaseZone, richContent } = useContext(StateContext)
    const {
        postPurchaseFormLabel,
        postPurchaseFormTitle,
        postPurchaseFormDescription,
        postPurchaseWidget
    } = postPurchaseZone || {}
    const formTitle = postPurchaseFormTitle || postPurchaseFormLabel

    if (!richContent?.postPurchaseForm) {
        return null
    }

    return (
        <div className="sps2-pdp_richContent--form sps2-pdp_wrap--800">
            {!postPurchaseWidget && formTitle && (
                <h3
                    className="mds-font_header--3 sps2-pdp_richContent--form-title"
                    tabIndex="-1"
                >
                    {formTitle}
                </h3>
            )}
            {!postPurchaseWidget && postPurchaseFormDescription && (
                <h3
                    className="mds-font_paragraph sps2-pdp_richContent--form-description"
                    tabIndex="-1"
                >
                    {postPurchaseFormDescription}
                </h3>
            )}
            <RichContent richContentObj={richContent.postPurchaseForm} />
        </div>
    )
}

export default PostPurchaseForm
